// ================  公共 start ======================================================================

import { getRewardDetail } from "@/api/system";

/**
 * 根据key获取value
 * @param optionArr
 * @param key
 */
export function getValue(optionArr, key) {
  let resultVal = "";
  if (!optionArr || optionArr.length === 0) {
    return resultVal;
  }
  optionArr.map(item => {
    if (item.key === key) {
      resultVal = item.value;
    }
  });
  return resultVal;
}

/**
 * 获取短信的类型 register-注册，login-登录，changepassword-修改密码
 * @type {{}}
 */
export const SMS_TYPE = {
  REGISTER: "register",
  LOGIN: "login",
  CHANGEPASSWORD: "changepassword"
};

/**
 * 上传图片的类型
 *  CATEGORY-商品类目图标,
 *  BRAND-品牌LOGO,
 *  SHOP-店铺LOGO,
 *  GOODS-商品图片,
 *  SPECS-商品规格图片,
 *  NEWS-资讯图片
 *  COMMON-公共,
 * @type {{}}
 */
export const UPLOAD_IMG_TYPE = {
  CATEGORY: "CATEGORY",
  BRAND: "BRAND",
  SHOP: "SHOP",
  GOODS: "GOODS",
  SPECS: "SPECS",
  COMMON: "COMMON",
  NEWS: "NEWS"
};

/**
 * 弹框的标题
 * @type {{CREATE: string, UPDATE: string}}
 */
export const DIALOG_TITLE_TYPE = {
  UPDATE: "编辑",
  CREATE: "添加"
};

/**
 * 附件类型 0-没有，1-视频，2-文件，
 * @type {[{value: string, key: number},{value: string, key: number}]}
 */
export const ATT_TYPE = [
  {
    key: 0,
    value: "没有"
  },
  {
    key: 1,
    value: "视频"
  },
  {
    key: 2,
    value: "文件"
  }
];

// ================  公共 end ======================================================================
/**
 * 用户的状态
 * @type {[{value: string, key: number},{value: string, key: number}]}
 */
export const IS_STATUS = [
  {
    key: 0,
    value: "正常"
  },
  {
    key: 1,
    value: "冻结"
  }
];
/**
 * 菜单类型
 * @type {[{value: string, key: string},{value: string, key: string}]}
 */
export const MENU_TYPE = [
  {
    key: "MENU",
    value: "菜单"
  },
  {
    key: "ACTION",
    value: "操作"
  }
];

/**
 * 店铺状态 0-待审核，1-正常，2-休业中，3-关闭
 * @type {[{value: string, key: number}]}
 */
export const SHOP_STATUS = [
  {
    key: 0,
    value: "待审核"
  },
  {
    key: 1,
    value: "正常"
  },
  {
    key: 2,
    value: "休业中"
  },
  {
    key: 3,
    value: "关闭"
  }
];

/**
 * 品牌状态 0-待认证，1-已认证，2:未通过,3-已停售
 * @type {{TO_BE_REVIEWED: number}}
 */
export const SHOP_STATUS_VAL = {
  TO_BE_REVIEWED: 0
};

/**
 * 店铺审核状态 1-审核通过，4-审核不通过
 * @type {[{value: string, key: number},{value: string, key: number},{value: string, key: number}]}
 */
export const SHOP_EXAMINE_STATUS = [
  {
    key: 1,
    value: "审核通过"
  },
  {
    key: 4,
    value: "审核不通过"
  }
];

/**
 * 类目状态 0-正常，1-隐藏
 * @type {[{value: string, key: string},{value: string, key: string}]}
 */
export const CATEGORY_STATUS = [
  {
    key: 0,
    value: "正常"
  },
  {
    key: 1,
    value: "隐藏"
  }
];

/**
 * 品牌状态 0-待认证，1-已认证，2:未通过,3-已停售
 * @type {[{value: string, key: string},{value: string, key: string}]}
 */
export const BRAND_STATUS = [
  {
    key: 0,
    value: "待审核"
  },
  {
    key: 1,
    value: "已审核"
  },
  {
    key: 2,
    value: "未通过"
  },
  {
    key: 3,
    value: "已停售"
  }
];
/**
 * 品牌状态 0-待认证，1-已认证，2:未通过,3-已停售
 * @type {{TO_BE_REVIEWED: number}}
 */
export const BRAND_STATUS_VAL = {
  TO_BE_REVIEWED: 0,
  AUTHENTICATED: 1,
  NOT_PASS: 2,
  HALT_SALES: 3
};

/**
 * 店铺变更状态：0-待审核，1-审核通过，4-审核失败
 * @type {[{value: string, key: string},{value: string, key: string}]}
 */
export const CHANAGE_STATUS = [
  {
    key: 0,
    value: "待审核"
  },
  {
    key: 1,
    value: "审核通过"
  },
  {
    key: 4,
    value: "审核失败"
  }
];

/**
 * 审核状态 2-审核通过，4-审核不通过
 * @type {[{value: string, key: number},{value: string, key: number},{value: string, key: number}]}
 */
export const EXAMINE_STATUS = [
  {
    key: 1,
    value: "审核通过"
  },
  {
    key: 2,
    value: "审核不通过"
  }
];
/**
 * 商品状态 0-待审核，1-未上架，2-已上架
 * @type {[{value: string, key: number},{value: string, key: number},{value: string, key: number}]}
 */
export const PRODUCT_STATUS = [
  {
    key: 0,
    value: "待审核"
  },
  {
    key: 1,
    value: "未上架"
  },
  {
    key: 2,
    value: "已上架"
  },
  {
    key: 3,
    value: "审核失败"
  }
];
/**
 * 商品类型：0-普通，1-爆单专区，2-好物专区
 * @type {[{value: string, key: number},{value: string, key: number},{value: string, key: number}]}
 */
export const PRODUCT_TYPE = [
  {
    key: 0,
    value: "普通"
  },
  {
    key: 1,
    value: "爆单专区"
  },
  {
    key: 2,
    value: "好物专区"
  }
];
/**
 * 商品是否已删除：0-未删除，1-已删除
 * @type {[{value: string, key: number},{value: string, key: number},{value: string, key: number}]}
 */
export const PRODUCT_IS_DELETE = [
  {
    key: 0,
    value: "未删除"
  },
  {
    key: 1,
    value: "已删除"
  }
];
/**
 * 商品审核状态 1-审核通过，3-审核不通过
 * @type {[{value: string, key: number},{value: string, key: number},{value: string, key: number}]}
 */
export const PRODUCT_EXAMINE_STATUS = [
  {
    key: 1,
    value: "审核通过"
  },
  {
    key: 3,
    value: "审核不通过"
  }
];

/**
 * 发货时效：1-24小时内发货，2-48小时内发货，3-大于48小时发货
 * @type {[{value: string, key: number},{value: string, key: number}]}
 */
export const PRODUCT_DELIVERY_TIME = [
  {
    key: 1,
    value: "24小时内发货"
  },
  {
    key: 2,
    value: "48小时内发货"
  },
  {
    key: 3,
    value: "大于48小时发货"
  }
];

/**
 * 运费模板类型：1-自定义，2-包邮
 * @type {[{value: string, key: number},{value: string, key: number},{value: string, key: number}]}
 */
export const FREIGHT_TYPE = [
  {
    key: 1,
    value: "自定义"
  },
  {
    key: 2,
    value: "包邮"
  }
];

/**
 * 运费计价方式：1-按件数，2-按重量，3-按体积
 * @type {[{value: string, key: number},{value: string, key: number},{value: string, key: number}]}
 */
export const FREIGHT_PRICING_METHOD = [
  {
    key: 1,
    value: "按件数"
  },
  {
    key: 2,
    value: "按重量"
  },
  {
    key: 3,
    value: "按体积"
  }
];

/**
 * 抽奖模式：1-转盘，2-跑马灯
 * @type {[{value: string, key: number}]}
 */
export const RAFFLE_ACTIVITY_TYPE = [
  {
    key: 1,
    value: "转盘"
  },
  {
    key: 2,
    value: "跑马灯"
  }
];

/**
 * 状态：1-开启，2-关闭
 * @type {[{value: string, key: number}]}
 */
export const RAFFLE_ACTIVITY_STATUS = [
  {
    key: 1,
    value: "开启"
  },
  {
    key: 2,
    value: "关闭"
  }
];

/**
 * 账户类别
 * @type {[{value: string, key: number},{value: string, key: number},{value: string, key: number},{value: string, key: number},{value: string, key: number},null,null]}
 */
export const ACCOUNT_CATEGORY = [
  {
    key: "expend",
    value: "贡献值"
  },
  {
    key: "raffle",
    value: "抽奖次数"
  },
  {
    key: "exchange",
    value: "兑换券"
  },
  {
    key: "deduction",
    value: "抵扣券"
  },
  {
    key: "vcoin",
    value: "交易币"
  },
  {
    key: "bonus",
    value: "推广佣金"
  },
  {
    key: "redpacket",
    value: "现金红包"
  },
  {
    key: "balance",
    value: "现金余额"
  }
];
/**
 * 账户类型
 * @type {[{value: string, key: number},{value: string, key: number},{value: string, key: number},{value: string, key: number},{value: string, key: number},null,null]}
 */
export const ACCOUNT_TYPE = [
  {
    key: "lock",
    value: "锁定账户"
  },
  {
    key: "current",
    value: "活期账户"
  },
  {
    key: "quicken",
    value: "加速释放账户"
  }
];
/**
 * 购物赠送规则 模式
 * @type {[{value: string, key: string},{value: string, key: string},{value: string, key: string}]}
 */
export const GOODS_GIFT_RULE_MODEL = [
  {
    key: 1,
    value: "按单个商品设置"
  },
  {
    key: 2,
    value: "按默认设置"
  },
  {
    key: 3,
    value: "商品设置了按商品设置，否则按默认"
  }
];

/**
 * 账户互转规则 互转模式
 * @type {[{value: string, key: string},{value: string, key: string},{value: string, key: string}]}
 */
export const ACT_TRANSFER_RULE_MODEL = [
  {
    key: 0,
    value: "手动"
  },
  {
    key: 1,
    value: "自动"
  }
];
/**
 * 账户互转规则 互转方式
 * @type {[{value: string, key: string},{value: string, key: string},{value: string, key: string}]}
 */
export const ACT_TRANSFER_RULE_METHOD = [
  {
    key: 0,
    value: "账户余额"
  },
  {
    key: 1,
    value: "获得流水记录"
  }
];

/**
 * 账户互转规则 自动互转模式
 * @type {[{value: string, key: string},{value: string, key: string},{value: string, key: string}]}
 */
export const ACT_TRANSFER_RULE_AUTO_WAY = [
  {
    key: 1,
    value: "固定值"
  },
  {
    key: 2,
    value: "按比例"
  },
  {
    key: 3,
    value: "按锁定账户余额"
  }
];
/**
 * 系统赠送配置 计算模式
 * @type {*[]}
 */
export const SYS_GIFT_RULE_MODEL = [
  {
    key: 1,
    value: "用户当前贡献值占全网贡献值比例*赠送基数"
  }
];

/**
 * 系统赠送配置 赠送周期
 * @type {*[]}
 */
export const SYS_GIFT_RULE_CYCLE = [
  {
    key: "d",
    value: "每天"
  },
  {
    key: "w",
    value: "每周"
  },
  {
    key: "m",
    value: "每月"
  }
];

/**
 * 周选项
 * @type {*[]}
 */
export const WEEK_SEL = [
  {
    key: 1,
    value: "星期一"
  },
  {
    key: 2,
    value: "星期二"
  },
  {
    key: 3,
    value: "星期三"
  },
  {
    key: 4,
    value: "星期四"
  },
  {
    key: 5,
    value: "星期五"
  },
  {
    key: 6,
    value: "星期六"
  },
  {
    key: 7,
    value: "星期天"
  }
];
/**
 * 升级条件
 * @type {[{value: string, key: number}]}
 */
export const UPGRADES_CONDITIONS = [
  {
    key: 0,
    value: "所有都满足"
  },
  {
    key: 1,
    value: "满足其中一条"
  }
];

/**
 * 推广奖励类型：1-直推奖励，2-间推奖励，3-平级奖励，4-极差奖励
 * @type {[{value: string, key: number}]}
 */
export const REWARD_TYPE = [
  {
    key: 1,
    value: "直推奖励"
  },
  {
    key: 2,
    value: "间推奖励"
  },
  {
    key: 3,
    value: "平级奖励"
  },
  {
    key: 4,
    value: "极差奖励"
  }
];
/**
 * 类型：1-直推奖励，2-间推奖励，3-平级奖励，4-极差奖励
 * @type {{GRADUALLY_THRUST: number, DIRECT_THRUST: number, PARALLEL_GRADE: number, RANGE: number}}
 * @private
 */
export const REWARD_TYPE_ = {
  DIRECT_THRUST: 1,
  GRADUALLY_THRUST: 2,
  PARALLEL_GRADE: 3,
  RANGE: 4
};

/**
 * 账号状态：0-正常，1-停用
 * @type {[{value: string, key: number}]}
 */
export const MEMBER_STATUS = [
  {
    key: 0,
    value: "正常"
  },
  {
    key: 1,
    value: "停用"
  }
];

/**
 * 实名认证状态：0-未认证，1-审核中，2-已认证，3-认证失败
 * @type {[{value: string, key: number}]}
 */
export const MEMBER_CER_STATUS = [
  {
    key: 0,
    value: "未认证"
  },
  {
    key: 1,
    value: "审核中"
  },
  {
    key: 2,
    value: "已认证"
  },
  {
    key: 3,
    value: "认证失败"
  }
];
/**
 * 实名认证结果：2-认证通过，3-认证失败
 * @type {[{value: string, key: number},{value: string, key: number}]}
 */
export const MEMBER_EXAMINE_STATUS = [
  {
    key: 2,
    value: "认证通过"
  },
  {
    key: 3,
    value: "认证失败"
  }
];

/**
 * certType：1-居民身份证，2-护照
 * @type {[{value: string, key: number},{value: string, key: number}]}
 */
export const MEMBER_EXAMINE_TYPE = [
  {
    key: 1,
    value: "居民身份证"
  },
  {
    key: 2,
    value: "护照"
  }
];

/**
 * 银行状态：0-不可用，1-可用
 * @type {[{value: string, key: number},{value: string, key: number}]}
 */
export const BANK_STATUS = [
  {
    key: 0,
    value: "不可用"
  },
  {
    key: 1,
    value: "可用"
  }
];

/**
 * 提现结果：1-已打款，2-拒绝
 * @type {[{value: string, key: number},{value: string, key: number}]}
 */
export const FINANCE_WITHDRAWAL_STATUS = [
  {
    key: 0,
    value: "审核中"
  },
  {
    key: 1,
    value: "已打款"
  },
  {
    key: 2,
    value: "拒绝"
  }
];

/**
 * 状态：0-待支付，1-支付中，2-待发货，3-待收货，4-交易成功，5-交易关闭
 * @type {[{value: string, key: number},{value: string, key: number}]}
 */
export const ORDER_STATUS = [
  {
    key: 0,
    value: "待支付"
  },
  {
    key: 1,
    value: "支付中"
  },
  {
    key: 2,
    value: "待发货"
  },
  {
    key: 3,
    value: "待收货"
  },
  {
    key: 4,
    value: "交易成功"
  },
  {
    key: 5,
    value: "交易关闭"
  }
];

/**
 * 配送类型：1-快递，2-同城配送，3-EMS，4-平邮
 * @type {[{value: string, key: number},{value: string, key: number}]}
 */
export const ORDER_POSTAGES_TYPE = [
  {
    key: 1,
    value: "快递"
  },
  {
    key: 2,
    value: "同城配送"
  },
  {
    key: 3,
    value: "EMS"
  },
  {
    key: 4,
    value: "平邮"
  }
];

/**
 * 支付方式：wechat-微信，alipay-支付宝，vcoin-交易币，bonus-推广佣金，redpacket-现金红包，balance-现金余额
 * @type {[{value: string, key: number},{value: string, key: number}]}
 */
export const ORDER_PAY_PLATFORM = [
  {
    key: "wechat",
    value: "微信"
  },
  {
    key: "alipay",
    value: "支付宝"
  },
  {
    key: "vcoin",
    value: "交易币"
  },
  {
    key: "bonus",
    value: "推广佣金"
  },
  {
    key: "redpacket",
    value: "现金红包"
  },
  {
    key: "balance",
    value: "现金余额"
  }
];
/**
 * 区域代理 类型：1-省代理，2-市代理，3-县/区代理
 * @type {[{value: string, key: string}]}
 */
export const REGIONAL_TYPE = [
  {
    key: 1,
    value: "省代理"
  },
  {
    key: 2,
    value: "市代理"
  },
  {
    key: 3,
    value: "县/区代理"
  }
];

/**
 * 区域代理 状态：0-待审核，1-已生效，2-已取消
 * @type {[{value: string, key: string}]}
 */
export const REGIONAL_STATUS = [
  {
    key: 0,
    value: "待审核"
  },
  {
    key: 1,
    value: "已生效"
  },
  {
    key: 2,
    value: "已取消"
  }
];

/**
 * 	终端：ANDROID,IOS
 * @type {[{value: string, key: string}]}
 */
export const APP_VERSION_TERMINAL = [
  {
    key: "ANDROID",
    value: "ANDROID"
  },
  {
    key: "IOS",
    value: "IOS"
  }
];
/**
 * 	是否强制更新：0-不强制更新，1-强制更新
 * @type {[{value: string, key: string}]}
 */
export const APP_VERSION_FORCE = [
  {
    key: 0,
    value: "不强制更新"
  },
  {
    key: 1,
    value: "强制更新"
  }
];
/**
 * 	状态：0-新建，1-测试中，2-已发布，3-已下架
 * @type {[{value: string, key: string}]}
 */
export const APP_VERSION_STATUS = [
  {
    key: 0,
    value: "新建"
  },
  {
    key: 1,
    value: "测试中"
  },
  {
    key: 2,
    value: "已发布"
  },
  {
    key: 3,
    value: "已下架"
  }
];

/**
 * 	商城 类型：1-个人，2-公司
 * @type {[{value: string, key: string}]}
 */
export const MALL_TYPE = [
  {
    key: 1,
    value: "个人"
  },
  {
    key: 2,
    value: "公司"
  }
];

/**
 * 	商城 状态：0-待审核，1-正常，2-审核失败，3-冻结
 * @type {[{value: string, key: string}]}
 */
export const MALL_STATUS = [
  {
    key: 0,
    value: "待审核"
  },
  {
    key: 1,
    value: "正常"
  },
  {
    key: 2,
    value: "审核失败"
  },
  {
    key: 3,
    value: "冻结"
  }
];

/**
 * 	外部服务 类型：1-微信，2-支付宝，4-壹玖支付 5-Jeepay支付
 * @type {[{value: string, key: string}]}
 */
export const EXTERNAL_SERVICE_STATUS = [
  {
    key: 1,
    value: "微信"
  },
  {
    key: 2,
    value: "支付宝"
  },
  {
    key: 4,
    value: "壹玖支付"
  },
  {
    key: 5,
    value: "Jeepay支付"
  }
];

/**
 * 外部服务 类型：1-微信，2-支付宝，4-壹玖支付 5-Jeepay支付
 * @type {{GRADUALLY_THRUST: number, DIRECT_THRUST: number, PARALLEL_GRADE: number, RANGE: number}}
 * @private
 */
export const EXTERNAL_SERVICE_STATUS_ = {
  WECHAT: 1,
  ALIPAY: 2,
  YI_JIU: 4,
  JEEP_PAY: 5
};
/**
 * 分享海报状态：0-未启用，1-已启用
 * @type {[{value: string, key: number},{value: string, key: number}]}
 */
export const POINT_STATUS = [
  {
    key: 0,
    value: "未启用"
  },
  {
    key: 1,
    value: "已启用"
  }
];

/**
 * 微信支付方式（WX_H5-微信小程序，WX_NATIVE-微信二维码）
 * @type {[{value: string, key: number},{value: string, key: number}]}
 */
export const WECHAT_CODE = [
  {
    key: "WX_H5",
    value: "微信小程序"
  },
  {
    key: "WX_NATIVE",
    value: "微信二维码"
  }
];

/**
 * 支付宝支付方式（ALI_QR-支付宝H5）
 * @type {[{value: string, key: number},{value: string, key: number}]}
 */
export const ALIPAY_CODE = [
  {
    key: "ALI_QR",
    value: "支付宝H5"
  }
];
/**
 * 余额类型：1-消费获得，2-抽奖获得，3-直推获得，4-间推获得，5-级差奖，6-平级奖，7-充值，8-提现，9-支付，10-转出，11-转入，12-兑换，13-释放转出，14-释放转入，15-协议变更，16-买入，17-卖出
 */
export const BALANCE_TYPE = [
  {
    key: 1,
    value: "消费获得"
  },
  {
    key: 2,
    value: "抽奖获得"
  },
  {
    key: 3,
    value: "直推获得"
  },
  {
    key: 4,
    value: "间推获得"
  },
  {
    key: 5,
    value: "级差奖"
  },
  {
    key: 6,
    value: "平级奖"
  },
  {
    key: 7,
    value: "充值"
  },
  {
    key: 8,
    value: "提现"
  },
  {
    key: 9,
    value: "支付"
  },
  {
    key: 10,
    value: "转出"
  },
  {
    key: 11,
    value: "转入"
  },
  {
    key: 12,
    value: "兑换"
  },
  {
    key: 13,
    value: "释放转出"
  },
  {
    key: 14,
    value: "释放转入"
  },
  {
    key: 15,
    value: "协议变更"
  },
  {
    key: 16,
    value: "买入"
  },
  {
    key: 17,
    value: "卖出"
  },
  {
    key: 18,
    value: "系统赠送"
  },
  {
    key: 19,
    value: "区域代理收益"
  },
  {
    key: 20,
    value: "分红"
  }
];
/**
 * 发放状态：1-未发放，2-已发放
 * @type {[{value: string, key: number}]}
 */
export const DISTRIBUTION_STATUS = [
  {
    key: 1,
    value: "未发放"
  },
  {
    key: 2,
    value: "已发放"
  }
];

/**
 * 发货状态：0-无需发货，1-待发货，2-已发货，3-已收货
 * @type {[{value: string, key: number}]}
 */
export const DELIVERY_STATUS = [
  {
    key: 0,
    value: "无需发货"
  },
  {
    key: 1,
    value: "待发货"
  },
  {
    key: 2,
    value: "已发货"
  },
  {
    key: 3,
    value: "已收货"
  }
];
/**
 * 新闻 类型：1-推荐，2-热门，3-新闻，4-RWA资讯，5-商学院
 * @type {[{value: string, key: number}]}
 */
export const NEWS_TYPE = [
  {
    key: 1,
    value: "推荐"
  },
  {
    key: 2,
    value: "热门"
  },
  {
    key: 3,
    value: "新闻"
  },
  {
    key: 5,
    value: "商学院"
  },
  {
    key: 4,
    value: "RWA资讯"
  }
];

/**
 * 新闻 状态：0-隐藏，1-显示
 * @type {[{value: string, key: number}]}
 */
export const NEWS_STATUS = [
  {
    key: 0,
    value: "隐藏"
  },
  {
    key: 1,
    value: "显示"
  }
];

/**
 * 媒体类型：TXT-富文本，VIDEO-视频
 * @type {[{value: string, key: number}]}
 */
export const MEDIA_TYPE = [
  {
    key: "TXT",
    value: "富文本"
  }
  // {
  //   key: "VIDEO",
  //   value: "视频"
  // }
];
/**
 * 页面：1-APP首页，2-APP分类页，3-商学院资讯 4-爆单区，5-好物区
 * @type {[{value: string, key: string}]}
 */
export const APP_PAGE_TYPE = [
  {
    key: 1,
    value: "APP首页"
  },
  {
    key: 2,
    value: "APP分类页"
  },
  {
    key: 3,
    value: "商学院资讯"
  },
  {
    key: 4,
    value: "爆单区"
  },
  {
    key: 5,
    value: "好物区"
  },
  {
    key: 6,
    value: "积分专区"
  }
];
/**
 * 页面：0-隐藏，1-显示
 * @type {[{value: string, key: string}]}
 */
export const APP_PAGE_STATUS = [
  {
    key: 0,
    value: "隐藏"
  },
  {
    key: 1,
    value: "显示"
  }
];
/**
 * 售后订单状态：0-待受理，1-待买家寄回商品，2-待卖家收货，3-待卖家发货，4-待买家收货，5-退款中，6-退款失败，7-已完成，8-已作废
 * @type {[{value: string, key: string}]}
 */
export const AFTER_SALE_STATUS = [
  {
    key: 0,
    value: "待受理"
  },
  {
    key: 1,
    value: "待买家寄回商品"
  },
  {
    key: 2,
    value: "待卖家收货"
  },
  {
    key: 3,
    value: "待卖家发货"
  },
  {
    key: 4,
    value: "待买家收货"
  },
  {
    key: 5,
    value: "退款中"
  },
  {
    key: 6,
    value: "退款失败"
  },
  {
    key: 7,
    value: "已完成"
  },
  {
    key: 8,
    value: "已作废"
  }
];
/**
 * 售后订单 原因标签：1-我不想买了，2-下错单了，3-商家未发货，4-商品质量问题，5-商品实物与描述不符，6-商家发错货，7-假冒品牌，8-配件破损，9-主商品破损，10-协商一致退款，11-少件(少配件)，12-其他
 * @type {[{value: string, key: string}]}
 */
export const AFTER_SALE_REASON = [
  {
    key: 1,
    value: "我不想买了"
  },
  {
    key: 2,
    value: "下错单了"
  },
  {
    key: 3,
    value: "商家未发货"
  },
  {
    key: 4,
    value: "商品质量问题"
  },
  {
    key: 5,
    value: "商品实物与描述不符"
  },
  {
    key: 6,
    value: "商家发错货"
  },
  {
    key: 7,
    value: "假冒品牌"
  },
  {
    key: 8,
    value: "配件破损"
  },
  {
    key: 9,
    value: "主商品破损"
  },
  {
    key: 10,
    value: "协商一致退款"
  },
  {
    key: 11,
    value: "少件(少配件)"
  },
  {
    key: 12,
    value: "其他"
  }
];
/**
 * 售后类型：1-退款不退货，2-退货退款，3-换货
 * @type {[{value: string, key: string}]}
 */
export const AFTER_SALE_TYPE = [
  {
    key: 1,
    value: "退款不退货"
  },
  {
    key: 2,
    value: "退货退款"
  },
  {
    key: 3,
    value: "换货"
  }
];

/**
 * 交易所兑换单状态:0-申请中，1-待交易所确认，2-交易成功，3-交易失败
 * @type {[{value: string, key: string}]}
 */
export const EXCHANGE_VOUCHER_STATUS = [
  {
    key: 0,
    value: "申请中"
  },
  {
    key: 1,
    value: "待交易所确认"
  },
  {
    key: 2,
    value: "交易成功"
  },
  {
    key: 3,
    value: "交易失败"
  }
];
/**
 * 交易所兑换单方向：1-商城到交易所，2-交易所到商城
 * @type {[{value: string, key: string}]}
 */
export const EXCHANGE_VOUCHER_DIRECTION = [
  {
    key: 1,
    value: "商城到交易所"
  },
  {
    key: 2,
    value: "交易所到商城"
  }
];
/**
 * 交易所兑换单方向：状态：0-待绑定，1-已离开，2-已绑定,3-验证码无效，4-银行卡不持支，5-银行卡信息错误
 * @type {[{value: string, key: string}]}
 */
export const BANK_CARD_STATUS = [
  {
    key: 0,
    value: "待绑定"
  },
  {
    key: 1,
    value: "已离开"
  },
  {
    key: 2,
    value: "已绑定"
  },
  {
    key: 3,
    value: "验证码无效"
  },
  {
    key: 4,
    value: "银行卡不持支"
  },
  {
    key: 5,
    value: "银行卡信息错误"
  }
];
/**
 * 在线状态：0-离线，1-在线
 * @type {[{value: string, key: number}]}
 */
export const ONLINE_STATUS = [
  {
    key: 0,
    value: "离线"
  },{
    key: 1,
    value: "在线"
  },
]
